module.exports = __webpack_public_path__ + "static/Foto1-6054351d0c7d45ef61e4c9ec09d95206.png";